import {connect} from 'react-redux';
import CashRegisterScreen from '../../components/screens/CashRegisterScreen';
import {getTicket, getOpenCashRegisters, openCashRegister, getCashRegister, checkInTicket, checkOutSupporter, leaveCashRegister, closeCashRegister, getClosedCashRegisters, closeTicket, printShiftInfos} from '../../actions/cashRegisterAction';

const mapStateToProps = state => {
    return {
        cashRegister: state.cashRegister,
        project: state.project,
        printer: state.printer,
        roles: state.authorization.roles,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getTicket: (ean) => {
            dispatch(getTicket(ean))
        },
        getOpenCashRegisters: () => {
            dispatch(getOpenCashRegisters())
        },
        openCashRegister: (name, fiskalyClient) => {
            dispatch(openCashRegister(name, fiskalyClient))
        },
        getCashRegister: (id) => {
            dispatch(getCashRegister(id))
        },
        checkInTicket: (supporter, cashRegister, ean, gotAllFoodStamps, gotCarSticker, gotElectroBeer, ticketPrice, printShiftInfos, printerApiKey, items, stewardNumber) => {
            dispatch(checkInTicket(supporter, cashRegister, ean, gotAllFoodStamps, gotCarSticker, gotElectroBeer, ticketPrice, printShiftInfos, printerApiKey, items, stewardNumber));
        },
        checkOutSupporter: (supporter, cashRegister, ean, gotPresent, ticketPrice) => {
            dispatch(checkOutSupporter(supporter, cashRegister, ean, gotPresent, ticketPrice));
        },
        leaveCashRegister: () => {
            dispatch(leaveCashRegister());
        },
        closeCashRegister: (id) => {
            dispatch(closeCashRegister(id));
        },
        getClosedCashRegisters: () => {
            dispatch(getClosedCashRegisters());
        },
        closeTicket: () => {
            dispatch(closeTicket());
        },
        printShiftInfos: (ean) => {
            dispatch(printShiftInfos(ean))
        }
    }
};

const CashRegisterScreenContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CashRegisterScreen);

export default CashRegisterScreenContainer;
